import React from 'react';
import { inp, sel, lbl } from './shared';

interface Props {
  orgName: string; setOrgName: (s: string) => void;
  currency: string; setCurrency: (s: string) => void;
  localeVal: string; setLocaleVal: (s: string) => void;
  threshold: string; setThreshold: (s: string) => void;
  saved: boolean;
  saveError: string;
  onSave: () => void;
}

export function SettingsGeneral(p: Props) {
  return (
    <div style={{ animation: 'fadeSlideIn .25s ease-out' }}>
      <div style={{ fontSize: 16, fontWeight: 600, color: 'var(--text)', marginBottom: 4 }}>General</div>
      <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 20 }}>Organisation details and preferences</div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px 16px', marginBottom: 20 }}>
        <div>
          <label style={lbl}>Organisation name</label>
          <input value={p.orgName} onChange={e => p.setOrgName(e.target.value)} placeholder="e.g. Port of Auckland" style={inp} />
        </div>
        <div>
          <label style={lbl}>Currency</label>
          <input value={p.currency} onChange={e => p.setCurrency(e.target.value)} maxLength={3} style={{ ...inp, width: 80 }} />
        </div>
        <div>
          <label style={lbl}>Date format</label>
          <select value={p.localeVal} onChange={e => p.setLocaleVal(e.target.value)} style={sel}>
            <option value="en-NZ">New Zealand (DD/MM/YYYY)</option>
            <option value="en-AU">Australia (DD/MM/YYYY)</option>
            <option value="en-US">United States (MM/DD/YYYY)</option>
            <option value="en-GB">United Kingdom (DD/MM/YYYY)</option>
          </select>
        </div>
        <div>
          <label style={lbl}>Default low stock threshold</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <input type="number" value={p.threshold} onChange={e => p.setThreshold(e.target.value)} style={{ ...inp, width: 80 }} />
            <span style={{ fontSize: 11, color: 'var(--text3)' }}>for new items</span>
          </div>
        </div>
      </div>

      {p.saveError && (
        <div style={{ fontSize: 12, color: 'var(--red)', background: 'var(--red-bg)', padding: '8px 12px', borderRadius: 8, marginBottom: 10 }}>
          {p.saveError}
        </div>
      )}
      <button className="hbtn acc" onClick={p.onSave} style={{ borderRadius: 8, padding: '10px 24px', fontSize: 13, fontWeight: 600 }}>
        {p.saved ? '✓ Saved' : 'Save changes'}
      </button>
    </div>
  );
}
